import React, { useState, useRef } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import { StandaloneSearchBox } from "react-google-maps/lib/components/places/StandaloneSearchBox";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormGroup,
  Label,
} from "reactstrap";

const MapRegion = withGoogleMap((props) => {
  const { center, marker, onMapClick } = props;

  return (
    <GoogleMap
      defaultZoom={15}
      center={center}
      onClick={onMapClick}
      defaultOptions={{
        streetViewControl: false,
        mapTypeControl: false,
      }}
    >
      {marker && <Marker position={marker} />}
    </GoogleMap>
  );
});

const MapWithSearchLoader = withScriptjs((props) => {
  const { center, marker, onMapClick, onPlacesChanged, searchBoxRef } = props;

  return (
    <div>
      {/* AREA DE BUSCA - Totalmente fora do mapa */}
      <div className="mb-3">
        <Label className="fw-bold">Pesquisar Endereço:</Label>
        <StandaloneSearchBox
          ref={searchBoxRef}
          onPlacesChanged={onPlacesChanged}
        >
          <Input
            type="text"
            placeholder="Digite o endereço para buscar..."
            className="form-control"
            style={{ width: "100%" }}
          />
        </StandaloneSearchBox>
      </div>

      {/* AREA DO MAPA */}
      <div
        style={{
          height: "400px",
          border: "1px solid #ddd",
          borderRadius: "4px",
        }}
      >
        <MapRegion
          containerElement={<div style={{ height: `100%` }} />}
          mapElement={<div style={{ height: `100%` }} />}
          center={center}
          marker={marker}
          onMapClick={onMapClick}
        />
      </div>
    </div>
  );
});

export default ({ isOpen, toggle, initialCoords, onConfirm }) => {
  const defaultCenter = { lat: -10.9472, lng: -37.0731 };
  const searchBoxRef = useRef(null);

  const [center, setCenter] = useState(
    initialCoords && initialCoords.lat ? initialCoords : defaultCenter
  );

  const [marker, setMarker] = useState(
    initialCoords && initialCoords.lat ? initialCoords : null
  );

  const handleMapClick = (event) => {
    const newMarker = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };
    setMarker(newMarker);
  };

  const handlePlacesChanged = () => {
    const places = searchBoxRef.current.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      const location = place.geometry.location;
      const newCoords = {
        lat: location.lat(),
        lng: location.lng(),
      };
      setCenter(newCoords);
      setMarker(newCoords);
    }
  };

  const handleConfirm = () => {
    if (marker) {
      onConfirm(marker.lat, marker.lng);
      toggle();
    }
  };

  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Selecionar Localização</ModalHeader>

      <ModalBody>
        <MapWithSearchLoader
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&v=3.exp&libraries=geometry,drawing,places`}
          loadingElement={
            <div style={{ height: `100%`, minHeight: "400px" }} />
          }
          containerElement={<div style={{ height: `100%` }} />}
          center={center}
          marker={marker}
          onMapClick={handleMapClick}
          onPlacesChanged={handlePlacesChanged}
          searchBoxRef={searchBoxRef}
        />

        {marker && (
          <div className="mt-2 alert alert-info py-2">
            <small>
              <strong>Local selecionado:</strong> {marker.lat.toFixed(6)},{" "}
              {marker.lng.toFixed(6)}
            </small>
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleConfirm} disabled={!marker}>
          Confirmar
        </Button>
      </ModalFooter>
    </Modal>
  );
};
